'use client';

import { UseCategoriesOptions, useCategoryChoice } from '@liquorice/next-search';
import React from 'react';

export interface CategorySelectFieldProps extends UseCategoriesOptions {
  label: string;
  allLabel?: string;
}

const CategorySelectField = ({ label, allLabel = 'All', ...config }: CategorySelectFieldProps) => {
  const { options, ...choice } = useCategoryChoice(config);

  const handleChange = (ev: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = Array.from(ev.target.selectedOptions).map((option) => option.value);
    choice.setValue(selected);
  };

  return (
    <div className="">
      <label className="text-2xl font-medium">
        {label}
        <select
          className="text-tBase form-select block w-full min-w-60 rounded-lg border border-midnight-blue-500 px-4 py-2 pr-10 text-base focus:border-midnight-blue-500 focus:ring-midnight-blue-500"
          name={choice.name}
          multiple={choice.multiple}
          value={choice.value}
          onChange={handleChange}>
          <option value="">{allLabel}</option>
          {options?.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
};

export default CategorySelectField;
